import { render, staticRenderFns } from "./ThermostatsIndex.vue?vue&type=template&id=4b3a59f2&"
import script from "./ThermostatsIndex.vue?vue&type=script&lang=js&"
export * from "./ThermostatsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports